import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";

const SortPersonsForm =  (props) => {
  return (
    <form>
      <div className={'form-row'}>
        <div className={'form-group col-7'}>
          <Field name="sortBy" label={'Sort By'} component={RenderSelectField} fullWidth>
            <MenuItem value={'username'} >{'Username'}</MenuItem>
            <MenuItem value={'email'} >{'Email'}</MenuItem>
            <MenuItem value={'role'} >{'Role'}</MenuItem>
            <MenuItem value={'department'} >{'Department'}</MenuItem>
          </Field>
        </div>
        <div className={'form-group col-5'}>
          <Field name={'sortOrder'} label={'Sort order'} component={RenderSelectField} fullWidth>
            <MenuItem value={'asc'}>{'ASC'}</MenuItem>
            <MenuItem value={'desc'}>{'DESC'}</MenuItem>
          </Field>
        </div>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'sortPersonsForm',
})(SortPersonsForm);



// WEBPACK FOOTER //
// ./src/components/personsList/sortPersonsForm.js